import { motion } from "framer-motion";
import {
  FaArrowRight,
  FaDownload,
  FaGithub,
  FaLinkedin,
  FaWordpress,
  FaReact,
} from "react-icons/fa";
import { SiNextdotjs, SiTailwindcss } from "react-icons/si";

export default function Hero() {
  return (
    <section
      id="home"
      className="relative overflow-hidden bg-[#050816] pt-32 pb-24 lg:min-h-screen flex items-center"
    >
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden">

        <div className="absolute -top-40 -left-40 h-96 w-96 rounded-full bg-blue-600/20 blur-[120px]" />

        <div className="absolute bottom-0 right-0 h-[450px] w-[450px] rounded-full bg-cyan-500/10 blur-[140px]" />

        <div className="absolute left-1/2 top-0 h-full w-px bg-gradient-to-b from-transparent via-white/10 to-transparent" />

      </div>

      <div className="container relative z-10">

        <div className="grid gap-16 items-center lg:grid-cols-2">

          {/* Left */}

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: .8 }}
          >

            <span className="inline-flex rounded-full border border-blue-500/30 bg-blue-500/10 px-5 py-2 text-sm text-blue-400">

              Senior Frontend Developer

            </span>

            <h1 className="mt-8 text-5xl font-black leading-tight lg:text-7xl">

              Moobeen{" "}
              <span className="text-blue-500">
                Quader
              </span>

            </h1>

            <h2 className="mt-6 text-2xl font-semibold text-slate-300 lg:text-3xl">

              React • Next.js • WordPress

            </h2>

            <p className="mt-8 max-w-xl text-lg leading-8 text-slate-400">

              I build high-performance websites and modern web applications
              using React, Next.js, Tailwind CSS and Headless WordPress.

              During the last 10+ years I've delivered more than
              <span className="text-white font-semibold">
                {" "}1000 successful websites
              </span>
              {" "}focused on speed, SEO and exceptional user experience.

            </p>

            <div className="mt-12 flex flex-wrap gap-5">

              <a
                href="#projects"
                className="group flex items-center gap-3 rounded-xl bg-blue-600 px-8 py-4 font-semibold duration-300 hover:bg-blue-700"
              >
                View Projects

                <FaArrowRight className="duration-300 group-hover:translate-x-2" />

              </a>

              <a
                href="/resume.pdf"
                className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-8 py-4 backdrop-blur hover:bg-white/10"
              >
                <FaDownload />

                Resume

              </a>

            </div>

            {/* Social */}

            <div className="mt-12 flex items-center gap-5">

              <a
                href="https://github.com/"
                className="flex h-12 w-12 items-center justify-center rounded-full border border-white/10 bg-white/5 hover:bg-blue-600 duration-300"
              >
                <FaGithub />
              </a>

              <a
                href="https://www.linkedin.com/in/moobeen-quader-a40099b1"
                className="flex h-12 w-12 items-center justify-center rounded-full border border-white/10 bg-white/5 hover:bg-blue-600 duration-300"
              >
                <FaLinkedin />
              </a>

            </div>

            {/* Tech */}

            <div className="mt-16 flex flex-wrap gap-5">

              <div className="flex items-center gap-3 rounded-xl bg-white/5 px-5 py-4 border border-white/10">

                <FaReact className="text-cyan-400 text-2xl" />

                React

              </div>

              <div className="flex items-center gap-3 rounded-xl bg-white/5 px-5 py-4 border border-white/10">

                <SiNextdotjs className="text-white text-2xl" />

                Next.js

              </div>

              <div className="flex items-center gap-3 rounded-xl bg-white/5 px-5 py-4 border border-white/10">

                <SiTailwindcss className="text-sky-400 text-2xl" />

                Tailwind

              </div>

              <div className="flex items-center gap-3 rounded-xl bg-white/5 px-5 py-4 border border-white/10">

                <FaWordpress className="text-blue-500 text-2xl" />

                WordPress

              </div>

            </div>

          </motion.div>

          {/* Right */}

          <motion.div
            initial={{ opacity: 0, scale: .9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: .8 }}
            className="relative flex justify-center"
          >

            {/* Glow */}

            <div className="absolute h-[420px] w-[420px] rounded-full bg-blue-600/20 blur-[100px]" />

            {/* Image */}

            <div className="relative overflow-hidden rounded-[40px] border border-white/10 bg-gradient-to-b from-blue-600/20 to-slate-900 p-4 shadow-2xl">

              <img
                src="/images/profile.jpg"
                alt="Moobeen Quader"
                className="w-full max-w-md rounded-[28px]"
              />

            </div>

            {/* Floating Card */}

            <motion.div
              animate={{ y: [0, -12, 0] }}
              transition={{ repeat: Infinity, duration: 4 }}
              className="absolute -left-5 top-10 rounded-2xl border border-white/10 bg-slate-900/90 px-6 py-5 backdrop-blur"
            >
              <h4 className="text-4xl font-black text-blue-400">

                10+

              </h4>

              <p className="text-slate-400">

                Years Experience

              </p>

            </motion.div>

            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{ repeat: Infinity, duration: 5 }}
              className="absolute -right-5 bottom-10 rounded-2xl border border-white/10 bg-slate-900/90 px-6 py-5 backdrop-blur"
            >
              <h4 className="text-4xl font-black text-blue-400">

                1000+

              </h4>

              <p className="text-slate-400">

                Websites Delivered

              </p>

            </motion.div>

          </motion.div>

        </div>

      </div>
    </section>
  );
}